/** @format */

import { notificationConstants } from '../notifications/notifications';
import { apiCall } from '../../core/apiCall';
import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const platformResellerConstants = {
    PLATFORM_RESELLER_LIST: 'platform_reseller_list',
    PLATFORM_RESELLER_ITEM: 'platform_reseller_item',
    PLATFORM_RESELLER_EDIT: 'platform_reseller_edit',
    PLATFORM_RESELLER_DELETE: 'platform_reseller_delete',
    PLATFORM_RESELLER_MANAGE: 'platform_reseller_manage',
    PLATFORM_RESELLER_ADD: 'platform_reseller_add',
    PLATFORM_RESSELLER_SELECTED_LIST: 'platform_reseller_selected_list',
    PLATFORM_RESELLER_POOLS: 'platform_reseller_pools',
};

export class platformResellerActions extends defaultActions {
    static getList = (url, filter, orders, reducers) => {
        if (!reducers) {
            reducers = platformResellerConstants.PLATFORM_RESELLER_LIST;
        }
        return (dispatch) => {
            apiCall
                .get(url, filter, orders)
                .then((collections) => {
                    dispatch(success(collections));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(collections) {
            return { type: reducers, collections: collections };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };

    static get = (url) => {
        return (dispatch) => {
            apiCall
                .get(url)
                .then((item) => {
                    dispatch(success(item));
                })
                .catch((error) => {
                    if (error.status === 404) {
                        dispatch(itemNotFound(error));
                    } else {
                        dispatch(failure(error));
                    }
                });
        };

        function success(item) {
            return { type: platformResellerConstants.PLATFORM_RESELLER_ITEM, item: item };
        }

        function itemNotFound(error) {
            return { type: notificationConstants.NOTFOUND, error: error };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };

    static post = (url, params) => {
        return (dispatch) => {
            apiCall
                .post(url, params)
                .then((data) => {
                    dispatch(success(data));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(data) {
            return { type: platformResellerConstants.PLATFORM_RESELLER_ADD, data: data };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };

    static put = (url, params) => {
        return (dispatch) => {
            apiCall
                .put(url, params)
                .then((data) => {
                    dispatch(success(data));
                })
                .catch((error) => {
                    dispatch(failure(error));
                });
        };

        function success(data) {
            return { type: platformResellerConstants.PLATFORM_RESELLER_EDIT, data: data };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };

    static remove = (url) => {
        return (dispatch) => {
            apiCall
                .remove(url)
                .then(dispatch(success()))
                .catch((error) => {
                    failure(error);
                });
        };

        function success() {
            return { type: platformResellerConstants.PLATFORM_RESELLER_DELETE };
        }

        function failure(error) {
            return {
                type: notificationConstants.ERROR,
                error: error,
            };
        }
    };
}
